var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-warrper"},[_c('headerBox'),_c('div',{staticClass:"content"},[_c('keep-alive',[_c('router-view',{key:_vm.$route.path})],1)],1),_c('footerBox')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }